import _, { isEmpty } from 'lodash'
import React, { useEffect, useState, useMemo } from 'react';
import { Container, Row, Col, ListGroup, ListGroupItem, Form, FormGroup, Label, Input, Button, Card, CardBody } from 'reactstrap';
import Moment from 'moment'
import 'moment/locale/de'
import 'moment/locale/it'
import 'moment/locale/nl'

import LoadingOverlay from 'components/Indicator/LoadingOverlay'
import DeleteConfirmationModal from 'components/Modal/deleteConfirmation'
import ReactCSSTransitionGroup from 'react-addons-css-transition-group'
import PageTitle from 'components/Title/PageTitle'
import AlertNotSubscribe from 'components/Alert'
import Lang from 'Lang/General'
import DialogueBox from './DialogueBox'
import WithHOC from './action'

const Legends = [
    {
      label: 'ALL',
      color: '#dc3545'
    },
    {
      label: "NEW_MESSAGES",
      color: "#002f4c"
    },
    {
      label: "MY_MSG",
      color: "#28a745"
    },
    {
      label: "OTHER_MSG",
      color: "#87CEEB"
    },
]

const DialogsUI = ({
  ... props
}) => {
  
  const [ dialogueIntervalId, setDialogueIntervalId ] = useState( null )
  const [ scrollIntoInternal, setScroll ] = useState(null)
  const [ currentTab,setTab ] = useState('ALL')
 
  useEffect(() => {
    Moment.locale( props.data.languageReducer.userSettings.admin_panel_language )
    let tmpIndex = _.findIndex(props.data.selectCenterReducer.selectedCenter.center.modules, { name: 'Customer Dialogue System' })
    
    props.getDialogueSetting()
    props.onChangeDialogsHOC('subscribedPackage', tmpIndex > -1)
    if( tmpIndex > -1 ) {
      props.getDialogs()
      const tmpInterval = setInterval(() => {
        props.getDialogs()
      }, 10000)
      return () => clearInterval( tmpInterval )
    }
  }, [])

  const filteredDialogs = useMemo(() => {
    if(props.dialogs?.[0]){
      if(currentTab === 'ALL') {
        return [ ... props.dialogs]
      }
  
      if(currentTab === 'NEW_MESSAGES') {
        return props.dialogs.filter( child => child.is_new)
      }
      if(currentTab === 'MY_MSG') {
        return props.dialogs.filter( child => child.is_joined)
      }
      if(currentTab === 'OTHER_MSG') {
        return props.dialogs.filter( child => !child.is_new && !child.is_joined)
      }
    } else {
      return []
    }
  }, [currentTab, props.dialogs])

  useEffect( () => {
    let tmpIntervalId = null
    var currentUrl = window.location.href;
    var urlParts = decodeURIComponent( currentUrl ).split("#/");
    
    if(window.location.hash.replace( '#/dashboard/dialogs/live#', '' ).indexOf('center_id') > -1 ){
      var pathAndQuery = urlParts[1]; // This contains "/dashboard/dialogs/live?center_id=2#Tgfz032UjvaFb5jj54002YFkIGAGPOSeX9xkOgRpPL8="
      var pathAndHashParts = pathAndQuery.split("#"); // Split at the second hash

      var queryPart = pathAndHashParts[0]; // This contains "/dashboard/dialogs/live?center_id=2"
      var secondHashValue = pathAndHashParts[1]; // This contains "Tgfz032UjvaFb5jj54002YFkIGAGPOSeX9xkOgRpPL8="

      // Extract the center_id using URLSearchParams
      var queryParams = new URLSearchParams(queryPart.split("?")[1]);
      var centerId = queryParams.get("center_id");

      if(props.data.selectCenterReducer.selectedCenter.center.id !== +centerId) {
        let tempCenter = _.find(props.data.profileReducer.profile.centers, child => child.id === +centerId)
        tempCenter && 
        props.setSelectCenter({center: tempCenter}, true)
      } 

      if( props.selectedDialogue.encrypted_id !== secondHashValue) {
        props.getSelectedDialogue( secondHashValue )
        window.history.replaceState( null, null, `${ window.location.origin }/#/dashboard/dialogs/live` )
      } else {
        if (!_.isEmpty(props.selectedDialogue)) {
          dialogueIntervalId > 0 && clearInterval( dialogueIntervalId )
          tmpIntervalId = setInterval(
            () => props.getSelectedDialogue( props.selectedDialogue.encrypted_id ),
            10000
          )
          setDialogueIntervalId( tmpIntervalId )
        }
      }
    } else {
      if ( 
        !isEmpty( window.location.hash.replace( '#/dashboard/dialogs/live', '' ) ) &&
        props.selectedDialogue.encrypted_id !== window.location.hash.replace( '#/dashboard/dialogs/live#', '' )
      ) {
        props.getSelectedDialogue( window.location.hash.replace( '#/dashboard/dialogs/live#', '' ) )
        window.history.replaceState( null, null, `${ window.location.origin }/#/dashboard/dialogs/live` )
      } else if ( props.selectedDialogue.id > 0 ) {
        if (!_.isEmpty(props.selectedDialogue)) {
          dialogueIntervalId > 0 && clearInterval( dialogueIntervalId )
          tmpIntervalId = setInterval(
            () => props.getSelectedDialogue( props.selectedDialogue.encrypted_id ),
            10000
          )
          setDialogueIntervalId( tmpIntervalId )
        }
      }
    }

    return () => tmpIntervalId && clearInterval( tmpIntervalId )
  }, [ props.selectedDialogue ] )

  useEffect( () => {
    if ( props.isDialogueLoaded && props.isDialogueSettingLoaded ) {
      let tmpDialogueFields = []

      props.dialogueSetting.dialogue_fields.map( dialogueField => {
        let tmpField = {
          ...dialogueField,
          dialogue_fields_id: dialogueField.id,
          info: ''
        }
        
        let tmpIndex = !isEmpty( props.selectedDialogue )
          ? props.selectedDialogue.dialogue_fields_infos.findIndex( info => info.dialogue_fields_id === dialogueField.id )
          : -1

        if ( tmpIndex > -1 ) {
          tmpField.info = props.selectedDialogue.dialogue_fields_infos[ tmpIndex ].info
        }

        tmpDialogueFields.push( tmpField )
      })

      props.onChangeDialogsHOC( 'dialogueFields', tmpDialogueFields )
    }
  }, [ props.isDialogueLoaded, props.isDialogueSettingLoaded, props.selectedDialogue ] )

  const onChangeField = (index, val) => {
    let temp = _.cloneDeep(props.dialogueFields)
    temp[index]['info'] = val

    props.onChangeDialogsHOC('dialogueFields', temp)
  }

  return (
    <>
      <PageTitle
        heading={Lang['DIALOGS'][props.data.languageReducer.userSettings.admin_panel_language]}
        icon="pe-7s-headphones icon-gradient bg-happy-itmeo"
        buttons={[]}
      />
      <ReactCSSTransitionGroup
        component="div"
        transitionName="TabsAnimation"
        transitionAppear={true}
        transitionAppearTimeout={0}
        transitionEnter={false}
        transitionLeave={false}>
        <Container fluid>
          <Row>
            <Col sm={ 12 } className='p-0' >
              { !props.subscribedPackage && <AlertNotSubscribe { ...props } /> }
            </Col>
          </Row>
          {
            !_.isEmpty(props.selectedDialogue) && (
              <div className="d-flex mb-2" style={{ gap: 7, marginRight: -15 }}>
                <Button
                  color="danger"
                  size="lg"
                  className="ml-auto"
                  onClick={() => {
                    props.onChangeDialogsHOC('showEnd', true)
                  }}
                >
                  {Lang['END_DIALOGUE'][props.data.languageReducer.userSettings.admin_panel_language]}
                </Button>
              </div>
            )
          }
          <Card style={{ margin: '0px -15px'}} className="mb-2">
            <CardBody style={{ display: 'flex', gap: 7 }}>
            {
              Legends.map(child => (
                <Button
                  style={{ background: child.color, borderColor: child.color }}
                  onClick={() => setTab(child.label)}
                >
                  {Lang[child.label][props.data.languageReducer.userSettings.admin_panel_language]}
                </Button>
              ))
            }
            </CardBody>
          </Card>
          <Row>
            <Col md="3" className="bg-white border-right" style={{ paddingTop: 15, height: '80vh' }}>
              <ListGroup style={{ height: "100%", maxHeight: '77vh', overflow: 'scroll', width: '100%' }} className='mb-3'>
                {
                  filteredDialogs.map(val => (
                    <ListGroupItem style={{ 
                      background: val.is_new 
                        ? '#002f4c'
                        : val.is_joined
                          ? '#28a745'
                          : '#87CEEB',
                      cursor: 'pointer', 
                      position: 'relative',
                      marginBottom: 5,
                      borderRadius: 10,
                      color: 'white',
                      ... props.selectedDialogue.id === val.id ? {
                        border: '6px solid #fd4500'
                      }: {}
                    }} onClick={() => {
                      props.getSelectedDialogue(val.encrypted_id)
                    }}>
                      <small className='mb-1' style={{display: 'block'}}>
                        {( val.first_name || val.last_name ) ? `${val.first_name} ${val.last_name}` : '-' }
                      </small>
                      <strong style={{ wordBreak: "break-word" }} >{ 
                        val?.last_message?.content || Lang['NEW_DIALOGUE'][props.data.languageReducer.userSettings.admin_panel_language]  
                      }</strong>
                      <small style={{display: 'block', textAlign: 'end', whiteSpace: "nowrap"}}>
                        { val.last_message.created_at ? Moment(val.last_message.created_at).format('h:mm A') : Moment(val.created_at).format('h:mm A')}
                      </small>
                      {
                        val.unread_count > 0 && (
                          <div className="bg-danger text-white" style={{ position: 'absolute', top: 10, right: 10, width: 20, height: 20, display: 'grid', placeContent: 'center', borderRadius: '50%' }}>
                            {val.unread_count}
                          </div>
                        )
                      }
                    </ListGroupItem>
                  ))
                }
              </ListGroup>
            </Col>
            {/* Center Panel: Dialog Messages */}
            <Col md="6" className="bg-white border-right py-3" style={{ height: "80vh" }}>
              <DialogueBox 
                { ...props } 
                onCheckLastRead={ true }
                scrollIntoInternal={scrollIntoInternal}
                setScroll={setScroll}
                isInternalDialogue={ false }
                selectedLanguage={ props.data.languageReducer.userSettings.admin_panel_language }
              />
            </Col>

            {/* Right Panel: Admin Edit Panel */}
            <Col md="3" className="bg-white" style={{ height: "80vh", overflow: 'scroll', padding: 15 }}>
              {
                !_.isEmpty(props.selectedDialogue) && (
                  <>
                    {
                      props.dialogueFields?.[0] && (
                      <Card className="mb-3" style={{ height: '45%', overflow: 'auto' }}>
                        <CardBody>
                          <Form>
                            {
                              props.dialogueFields.map((formChild, formIndex) => (
                                <FormGroup>
                                  <Label>
                                    {formChild.title[props.data.languageReducer.userSettings.admin_panel_language]}
                                  </Label>
                                  <Input
                                    type="text" 
                                    value={formChild.info}
                                    onChange={ e => onChangeField(formIndex, e.target.value)}
                                  />
                                </FormGroup>
                              ))
                            }
                            <Button className="mb-3" color="success" block onClick={() => props.createAndUpdateDialogueFieldsInfos()}>
                              {Lang['SAVE'][props.data.languageReducer.userSettings.admin_panel_language]}
                            </Button>
                            <hr />
                          </Form>
                        </CardBody>
                      </Card>
                      )
                    }
                    <DialogueBox 
                      { ...props } 
                      onCheckLastRead={ false }
                      isInternalDialogue={ true }
                      setScroll={setScroll}
                      scrollIntoInternal={scrollIntoInternal}
                      selectedLanguage={ props.data.languageReducer.userSettings.admin_panel_language }
                    />
                  </>
                )
              }
            </Col>
          </Row>
          {
            props.showEnd && (
              <DeleteConfirmationModal
                title={ Lang['END_DIALOGUE'][props.data.languageReducer.userSettings.admin_panel_language]}
                handleModalClose={() => props.onChangeDialogsHOC('showEnd', false)}
                confirmAction={() => {
                  clearInterval( dialogueIntervalId )
                  setDialogueIntervalId(null)
                  props.closeDialog(props.selectedDialogue.encrypted_id)
                }}
                content={Lang['END_DIALOGUE_CONFIRMATION'][props.data.languageReducer.userSettings.admin_panel_language]}
                lang={props.data.languageReducer.userSettings.admin_panel_language}
              />
            )
          }
        </Container>
      </ReactCSSTransitionGroup>
      { props.onLoadDialogsHOC && <LoadingOverlay /> }
    </>
  );
};

export default WithHOC(DialogsUI);
